import {styled} from '../../../utils';

export default styled('span')({verticalAlign: 'middle'});



// WEBPACK FOOTER //
// ./src/components/Avatar/private/AvatarText.tsx